<template>
   
        <!-- 下载 -->
        <div class="toastDownload" v-show="showdownlod == '1'" @click="quxiao()">
            <div class="modela">
                    <h1>{{logintitle!=''&& logintitle!='undefined'?logintitle:downloadmsg}}</h1>
                    <h1 v-if="secondLine != '' && secondLine != undefined" style="margin-top:0.15rem;">{{secondLine}}</h1>
                    <p v-if="logintitle!=''&&logintitle!='undefined'">{{downloadmsg}}</p>
                    <div>
                        <span class="quxiao" v-if="btn!='重新登录'" @click.stop="quxiao()">取消</span>
                        <span class="sure" @click.stop="downLoad()">{{btn}}</span> 
                    </div>
            </div>
        </div>
       
    
</template>

<script>
export default {
  name: 'pro-page',
  props: [
    'logintitle',
    'downloadmsg',
    'btn',
    'loginurl',
    'sureBuy',
    'secondLine'
  ],
  data(){
    return{
        address:'',
        title:'打开下载听见广播APP',
        isWechat:'0',
        //  提现跳转
        isWithdraw:false,
        showdownlod:'',
        showlogin:'1',
    }
  },

   methods:{
 
     downLoad:function(){
         var self = this;
       
        if(this.btn == '登录'){
            console.log(this.loginurl)
            setTimeout(()=>{
                self.$router.push({path:self.loginurl });
            },1000)

        }else if(self.downloadmsg == '您的播豆不足，是否现在购买?'){
            this.showdownlod = ''
            self.sureBuy()
        }else if(self.btn == '重新登录'){
            self.$router.push({path:'./change?channel_id='+self.cbct.getCookie('channel_id') })
        }else{
        
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                var ua = navigator.userAgent.split("(")[1].split(")")[0];
                // alert(ua);
                var phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
                if (phone[1].test(ua)) {
                    window.location.href='https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100594819?source=appshare&subsource=C100594819';
                } else if (phone[2].test(ua)) {
                    window.location.href='http://app.xiaomi.com/detail/760715';
                } else if (phone[3].test(ua)) {
                    window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
                } else if (phone[4].test(ua)) {
                    window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
                } else {
                    var uas = navigator.userAgent.toLowerCase();
                    if(uas.match(/MicroMessenger/i)=="micromessenger") {
                    window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.cbct.seefm';
                    }else{
                        window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.cbct.seefm';
                    }
                }
            }
            if (isIOS) {
                window.location.href='https://itunes.apple.com/cn/app/%E5%90%AC%E8%A7%81%E5%B9%BF%E6%92%AD-%E5%8F%AF%E5%90%AC%E5%8F%AF%E7%9C%8B%E7%9A%84%E5%B9%BF%E6%92%AD%E7%94%B5%E5%8F%B0%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD/id1439524045?mt=8';
            }
        }
     },
     quxiao:function(){
         this.showdownlod = '';
     }
  },
  created(){
    $('title').html(decodeURIComponent(this.cbct.getCookie('channel_name')));
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        this.address=this.cbct.androidDownloadAddress;
    }
    if (isIOS) {
        this.address=this.cbct.iosDownloadAddress;
    }
    if (this.$route.query.isWithdraw) {
      this.isWithdraw=true;
    }

  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .toastDownload{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        z-index: 100;
        .modela{
            position: absolute;
            width:6.22rem;
            height:auto;
            margin-left: 0.64rem;
            top: 50%;
            transform: translateY(-1.26rem);
            background: #fff;
            font-size: 0.28rem;
            // border-radius: 0.1rem;
            border-radius: 0.16rem;
            h1{
                margin-top: .64rem;
                font-size: 0.34rem;
                font-weight:bold;
                color:rgba(51,51,51,1);
                padding: 0 0.48rem;
            }
            p{
                // color: rgba(51, 51, 51, 1);
                color: rgba(0,0,0,.5);
                line-height: 1;
                text-align: center;
                font-size: 0.32rem;
                padding: 0 0.48rem;
                padding-top: 0.64rem;
            }
            div{
                margin-top: 0.66rem;
                display: flex;
                // justify-content: space-around;/
                // margin-bottom: .4rem;
                height:1.04rem;
                width:100%;
                // align-items: center;
                border-top: 0.01rem solid rgba(0, 0, 0, .2);
                font-family:PingFangSC-Medium,PingFang SC;
                letter-spacing: .1rem;


                .quxiao{
                    // width:50%;
                    flex:1;
                    // margin-left: 0.96rem;
                    color: rgba(102, 102, 102, .5);
                    // border: 1px solid rgba(102, 102, 102, 1);
                    // border-radius: 0.68rem;
                    // line-height: 1;
                    // padding: 0.2rem 0.52rem;
                    // text-align: center;
                    border-right: 0.01rem solid rgba(0, 0, 0, .2);
                    line-height: 1.04rem;
                    // opacity: 50%;
                    // font-weight:bold;
                    font-size: 0.32rem;
                    // opacity: .5;
                    font-family:PingFangSC-Medium,PingFang SC;


                }
                .sure{
                    // width:50%;
                    flex:1;
                    // margin-right: 0.96rem;
                    // color: rgba(204, 50, 50, 1);
                    // border: 1px solid rgba(204, 50, 50, 1);
                    // border-radius: 0.68rem;
                    // line-height: 1;
                    // padding: 0.2rem 0.52rem;
                    // text-align: center;
                    // font-weight:700;
                    color:rgba(68,115,225,1);
                    line-height: 1.04rem;
                    font-size: 0.32rem;
                    font-family:PingFangSC-Medium,PingFang SC;
               

                }
            }
        }
    }
</style>
